import { render, staticRenderFns } from "./readonlyContent.vue?vue&type=template&id=3c70d833&scoped=true&"
import script from "./readonlyContent.vue?vue&type=script&lang=js&"
export * from "./readonlyContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c70d833",
  null
  
)

export default component.exports